'use client';
import { ComponentType, useMemo } from 'react';

import { useTranslations } from 'next-intl';

import BenefitItem from '@/app/[locale]/(main)/live-predictions/[symbol]/_components/BenefitsGrid/BenefitItem';
import DiamondSimpleIcon from '@/assets/icons/benefits/diamond-simple.svg';
import LiquidityIcon from '@/assets/icons/benefits/dynamic-liquidity.svg';
import RocketIcon from '@/assets/icons/benefits/rocket.svg';
import ScalesIcon from '@/assets/icons/benefits/scales.svg';
import { Section } from '@/components/shared/Section';

type T_BenefitData = {
  Icon: ComponentType<{ className?: string }>;
  titleKey: string;
  descriptionKey: string;
};

const benefitsIcons: ComponentType<{ className?: string }>[] = [
  LiquidityIcon,
  DiamondSimpleIcon,
  ScalesIcon,
  RocketIcon
];

export default function PoolsBenefitsItems() {
  const t = useTranslations('pools');

  const benefitsData = useMemo<T_BenefitData[]>(
    () => [
      {
        Icon: benefitsIcons[0],
        titleKey: 'benefitTitle1',
        descriptionKey: 'benefitDescription1'
      },
      {
        Icon: benefitsIcons[1],
        titleKey: 'benefitTitle2',
        descriptionKey: 'benefitDescription2'
      },
      {
        Icon: benefitsIcons[2],
        titleKey: 'benefitTitle3',
        descriptionKey: 'benefitDescription3'
      },
      {
        Icon: benefitsIcons[3],
        titleKey: 'benefitTitle4',
        descriptionKey: 'benefitDescription4'
      }
    ],
    []
  );

  return (
    <Section className="py-6" container containerClassName="md:p-0">
      <div className="grid w-full grid-cols-1 md:grid-cols-2 md:gap-9 gap-4 justify-items-stretch ">
        {benefitsData.map((benefit, index) => (
          <BenefitItem
            key={index}
            Icon={benefit.Icon}
            title={t(benefit.titleKey)}
            description={t(benefit.descriptionKey)}
          />
        ))}
      </div>
    </Section>
  );
}
